import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { TdoSubnavItemModel } from '../tdo-subnav/models/tdo-subnav-item.model';
import { TdoSubnavEvent } from '../tdo-subnav/tdo-subnav.event';
import { TdoSubnavItemComponent } from '../tdo-subnav/tdo-subnav-item/tdo-subnav-item.component';
import { MenuConfigurationModel } from '../../../models/ui/menu/menu-configuration.model';
import { UiService } from '../../../services/ui.service';
import { isIterable } from 'rxjs/internal-compatibility';
import { Globals } from '../../../globals';
import { MenuItemConfigurationModel } from '../../../models/ui/menu/menu-item-configuration.model';
import { Router } from '@angular/router';
import { DialogService } from '../../../services/dialog.service';
import { AuthenticationService } from '../../../modules/auth/services/authentication.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { UserRoleEnum } from 'src/app/models/enum/user-role.enum';

@Component({
  selector: 'app-tdo-smartnav',
  templateUrl: './tdo-smartnav.component.html',
  styleUrls: ['./tdo-smartnav.component.scss']
})
export class TdoSmartnavComponent implements OnInit, AfterViewInit {
  @Input() menuName: string;
  @Input() mainContainer: HTMLDivElement;
  @Input() navbarMaxItems: number = 6;
  @Input() dataSource: TdoSubnavItemModel[] = [];
  @Input() currentRoute: string;

  @Output() selected = new EventEmitter<TdoSubnavEvent>();

  @ViewChildren(TdoSubnavItemComponent) navItems: QueryList<TdoSubnavItemComponent>;

  isShowMenu: boolean = false;
  usageItems: MenuItemConfigurationModel[] = [];
  navbarItems: TdoSubnavItemModel[] = [];
  hamburgerItems: TdoSubnavItemModel[] = [];
  isReady = false;

  width = 0;

  menu: MenuConfigurationModel;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkSize();
    // Extra check for cases where the browser is resized from double clicking the top bar instead of dragging with the mouse.  This
    // Fixes a bug where the navbar would be empty in this case.
    setTimeout(() => {
      this.checkSize();
    }, 10);
  }

  constructor(private uiService: UiService, private globals: Globals, private router: Router, private dialogService: DialogService,
    private messagingService: MessagingService, private authService: AuthenticationService) {

  }

  ngOnInit(): void {
    if (this.menuName) {
      this.uiService.getMenu('Main').subscribe((res) => {
        this.menu = res;
        if (this.menu) {
          this.uiService.getUserMostUsedMenuItems(this.menu.MenuID, this.authService.currentUserValue.authdata.userid).subscribe((userRes) => {
            this.usageItems = userRes;
            this.isReady = true;

            for (const mi of this.menu.cfgMenuItems) {
              if (this.isUserHasRole(mi.cfgMenuMasterItem.MenuItemName.toLowerCase())) {

                const sim = new TdoSubnavItemModel(mi.cfgMenuMasterItem.MenuItemName);
                sim.route = mi.cfgMenuMasterItem.CommandRout;
                sim.itemId = mi.MenuItemId;
                sim.menuId = mi.MenuID;
                this.dataSource.push(sim);
              }

            }
            this.usageItems = this.usageItems.filter(p => this.dataSource.map(e => e?.label).includes(p.cfgMenuMasterItem.MenuItemName));

            this.checkSize();
          });
        }
      });
    }
  }

  isUserHasRole(menu: string) {
    switch (menu) {
      case 'letters':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Letters);
      case 'case view':
      case 'medical history':
      case 'pain history':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.CaseMgmt) || this.authService.currentUserRolesIds.includes(UserRoleEnum.CaseMgmtViewOnly);
      case 'ledger':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Ledger);
      case 'fees':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Fees);
      case 'claims':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.InsuranceClaimsMgmt);
      case 'organizer':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.ImageOrganizer);
      case 'studio':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.ImagingStudio);
      case 'imaging center':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.ImagingCenter);
      case 'erx':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Erx);
      case 'treatmentPlan':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.TreatmentPlanning);
      case 'visit':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.VisitWizard);
      case 'insurance payment':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.PaymentFromInsurance);
      case 'payment audit':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.PaymentAudit);
      case 'reporting':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Reports);
      case 'referring doctors':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Configuration);
      case 'accounting sync.':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Reports);
      case 'insurance':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Insurance) || this.authService.currentUserRolesIds.includes(UserRoleEnum.InsuranceViewOnly);
      default:
        return true;
    }
  }
  checkSize() {
    this.width = this.mainContainer.getBoundingClientRect().width;
    if (this.mainContainer) {
      const amountCanHoldTotal = Math.floor((this.mainContainer.getBoundingClientRect().width / 80));
      const navbarPreferredItems = this.usageItems.map(p => {
        const item = new TdoSubnavItemModel(p.cfgMenuMasterItem.MenuItemName);
        item.route = p.cfgMenuMasterItem.CommandRout;
        item.itemId = p.MenuItemId;
        item.menuId = p.MenuID;
        return item;
      });

      this.navbarItems = [];
      if (navbarPreferredItems && navbarPreferredItems.length > 0) {
        for (let i = 0; i < amountCanHoldTotal; i++) {
          if (!this.navbarItems.includes(navbarPreferredItems[i])) {
            this.navbarItems.push(navbarPreferredItems[i]);
          }
        }
      }
      // Add all remaining to the burger menu
      this.hamburgerItems = this.dataSource.filter(p => !this.navbarItems.map(e => e?.label).includes(p?.label));
    } else {
      //
    }
  }

  ngAfterViewInit(): void {
    this.handleInitialSelection();
    this.checkSize();
    if (this.navItems && this.navItems.length > 0) {
      //
    } else {
      const ivl = setInterval(() => {
        // We must wait for the @ContentChildren to be available
        if (this.navItems && this.navItems.length > 0) {
          clearInterval(ivl);
        }
      }, 200);
    }
  }

  handleInitialSelection() {
    let section: string = '';
    if (this.currentRoute.includes('/')) {
      const ivl = setInterval(() => {
        if (isIterable(this.navItems)) {
          clearInterval(ivl);
          const idx = this.currentRoute.lastIndexOf('/');
          section = this.currentRoute.substring(idx + 1, this.currentRoute.length).toLowerCase();
          section = section.replace('-', ' ');
          const item = this.navItems.find(p => p.name?.toLowerCase() === section);
          if (item) {
            item.select();
          }
        }
      }, 100);
    } else {
      section = this.currentRoute;
    }
  }

  onSubnavItemSelected(event: TdoSubnavEvent) {
    for (const item of this.navItems) {
      if (item !== event.model) {
        item.isSelected = false;
      }
    }
    this.selected.emit(event);
  }

  handleHamburgerSelection(item: TdoSubnavItemModel) {
    this.isShowMenu = false;

    this.navItems.map(p => p.isSelected = false);

    const model = new TdoSubnavEvent(item.label, null);
    this.selected.emit(model);
  }

  onMenuClick() {
    this.isShowMenu = !this.isShowMenu;
  }

  onHamburgerItemMouseEnter(event: MouseEvent, item: TdoSubnavItemModel) {
    if (item.children.length > 0) {
      item.isShowMenu = true;
    }
  }

  onHamburgerItemLeave(event: MouseEvent, item: TdoSubnavItemModel) {
    item.isShowMenu = false;
  }

  onItemClicked(item: TdoSubnavItemModel) {
    this.uiService.updateMenuUsage(this.authService.currentUserValue.authdata.userid, item.itemId).subscribe(() => {
      //
    });
    this.isShowMenu = false;
    if (item.route) {
      if (item.route.startsWith('/configuration')) {
        let windowOptions = [
          'toolbar=no',
          'location=no',
          'menubar=no',
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');
        let storageName = item.label;
        let itemToStore = {};
        let postClosureEvents = [];

        this.messagingService.openPopUpWindow(item.route, windowOptions, storageName, itemToStore, postClosureEvents, true, item.label);
      }
      else {
        this.router.navigateByUrl(item.route);
      }
    } else {
      // Must be a popup or external link (i.e. letters, pain history)
      switch (item.label) {
        case 'Letters':
          this.uiService.openLettersWindow();
          break;
        case 'Accounting Sync.':
          this.uiService.openAccountingIntegrationWindow(true);
          break;
        case 'Studio':
          this.uiService.openImagingWindow(true);
          break;
        case 'Medical History':
          this.dialogService.openMedicalHistory(this.globals.currentPatientId);
          break;
        case 'Pain History':
          this.dialogService.openPainHistory(this.globals.currentPatientId);
          break;
        case 'Reporting':
          this.uiService.openReportWindow();
          break;
        case 'Referral Manager':
          this.uiService.openReferralWindow();
          break;
      }
    }
  }
}
